module.exports = __webpack_public_path__ + "media/damages/szkoda-2-016455fd.png";